import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "49",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M0 .5h48v48H0z"
}, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#475467",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M13 9.5v11h22v-11M13 39.5v-11h22v11"
}, null, -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#475467",
  "stroke-dasharray": "3 3",
  "stroke-width": "2",
  d: "M9 24.5h30"
}, null, -1 /* HOISTED */)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }